import React from "react";
import LegalPageLayout, { Section, SectionTitle, Paragraph, List } from "components/legal/LegalPageLayout.js";

export default () => {
  return (
    <LegalPageLayout
      productName="VIPSO"
      productUrl="/products/vipso"
      title="Refund Policy"
      lastUpdated="July 10, 2026"
    >
      <Section>
        <Paragraph>
          This Refund Policy applies to subscription purchases made through the VIPSO app on Google Play, operated by <strong>Spurnest Techlabs</strong>.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Google Play Subscriptions</SectionTitle>
        <Paragraph>
          All subscription payments are processed by Google Play. Spurnest Techlabs does not directly handle payment or refund transactions.
        </Paragraph>
        <Paragraph>
          To request a refund for a subscription, please follow Google Play's refund process:
        </Paragraph>
        <List>
          <li>Open Google Play Store → Account → Payments & subscriptions → Budget & history</li>
          <li>Select the VIPSO subscription and request a refund, or contact Google Play support</li>
          <li>Refunds are subject to Google Play's refund policy and eligibility criteria</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Cancellation</SectionTitle>
        <Paragraph>
          You may cancel your subscription at any time through Google Play. Cancellation takes effect at the end of the current billing period. No partial refunds are issued for unused subscription time unless required by applicable law.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Contact</SectionTitle>
        <Paragraph>
          For billing questions, contact us at{" "}
          <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>{" "}
          and we will assist you with the Google Play refund process.
        </Paragraph>
      </Section>
    </LegalPageLayout>
  );
};
